import { useEffect, useState } from "react"

import dayjs from "dayjs";

import {
    styled,
    Card,
    Grid,
    Stack,
    Button,
    Box,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Divider,
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    FormHelperText,
    InputLabel
} from '@mui/material';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../../../context/AppContext"

import { initialValues, validationSchema } from "../../../schema/reports/containersReportSchema"

// import { customInjectionProps as containerInjectionProps } from "../../../schema/repositories/containerSchema";

import DatePickerComponent from "../../../../../components/common/DatePickerComponent"

import { useReports } from "../../../../../hooks/api/useReports";

import { useTranslations } from '../../../../../hooks/useTranslations';
import { containerInjectionFields } from "../../../hooks/model/useContainer";

export function ContainersReportFilters(props) {

    const { t } = useTranslations({ ns: ["common", "_@report", "_@repositories"] })

    const {
        state,
        dispatch,
        actionTypes,
        // filterType
    } = props

    const columns = [
        { accessorKey: 'location_name', header: t('Location'), size: 90 },
        { accessorKey: 'to_location_name', header: t('toLocation'), size: 90 },
        { accessorKey: 'repo_number', header: t('containerNo'), size: 130 },
        { accessorKey: 'number_alternative', header: t('secondaryNo'), size: 130 },
        { accessorKey: 'load_date', header: t('loadDate') },
        { accessorKey: 'number_seal', header: t('sealNo') },
        { accessorKey: 'number_marking', header: t('containerMarking') },
        { accessorKey: 'shipper', header: t('shipper') },
        { accessorKey: 'custom_agent', header: t('customAgent') },
        { accessorKey: 'supervisor', header: t('supervisor') },
        { accessorKey: `${containerInjectionFields.totalCbm.retrieveKey}`, header: t('totalCbm') },
        { accessorKey: `${containerInjectionFields.totalValue.retrieveKey}`, header: t('totalValues') },
        { accessorKey: `${containerInjectionFields.totalWeight.retrieveKey}`, header: t('totalWeight') },
        { accessorKey: `${containerInjectionFields.totalPackQty.retrieveKey}`, header: t('totalPackQty') },
        { accessorKey: 'remark', header: t('remark') },
        // { accessorKey: 'address_1', header: 'Address #1' },
        // { accessorKey: 'address_2', header: 'Address #2' },
        // { accessorKey: 'postcode', header: 'Postcode' },
        // { accessorKey: 'area_name', header: 'Area' },
        // { accessorKey: 'state_name', header: 'State' },
        // { accessorKey: 'country_name', header: 'Country' },
        // { accessorKey: 'status', header: 'Status', size: 100, valueGetter: ({ row }) => `${row.status === "1" ? 'Confirmed' : 'Pending'}` },
        // { accessorKey: 'approve_status', header: 'Approval', size: 100, valueGetter: ({ row }) => `${row.status === "1" ? 'Approved' : 'Pending'}` },
        { accessorKey: 'ax_createusername', header: t('createdBy') },
        { accessorKey: 'ax_createdatetime', header: t('createdDateTime'), size: 170 },
        // {
        //     accessorKey: 'fullName',
        //     headerName: 'Full name',
        //     description: 'This column has a value getter and is not sortable.',
        //     sortable: false,
        //     width: 160,
        //     valueGetter: (params) =>
        //     `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        // },
    ]

    const { filterOperatorTypes } = useReports({});

    const { closeCustomDrawer } = useAppContextFeatures()

    const [dataDate, setDataDate] = useState()

    const onSubmit = () => {

        handleApply()

    }

    const check = (name, operator = '', defaultValue = '') => {

        let valid;

        if (operator) {
            valid = state.rules.find(i => i.name === name && i.operator === operator)
        } else {
            valid = state.rules.find(i => i.name === name)
        }

        if (valid) return valid.value

        return defaultValue
    }

    let mergeValues = {
        ...initialValues,
    }

    // console.log('check("ax_createdatetime", filterOperatorTypes.moreThanEq)', check("ax_createdatetime", filterOperatorTypes.moreThanEq))

    if (check("ax_createdatetime", filterOperatorTypes.moreThanEq)) {
        mergeValues = { ...mergeValues, createDate: { ...mergeValues.createDate, from: dayjs(check("ax_createdatetime", filterOperatorTypes.moreThanEq)) } }
    }

    if (check("ax_createdatetime", filterOperatorTypes.lessThanEq)) {
        mergeValues = { ...mergeValues, createDate: { ...mergeValues.createDate, to: dayjs(check("ax_createdatetime", filterOperatorTypes.lessThanEq)) } }
    }

    if (check("load_date", filterOperatorTypes.moreThanEq)) {
        mergeValues = { ...mergeValues, loadDate: { ...mergeValues.loadDate, from: dayjs(check("load_date", filterOperatorTypes.moreThanEq)) } }
    }

    if (check("load_date", filterOperatorTypes.lessThanEq)) {
        mergeValues = { ...mergeValues, loadDate: { ...mergeValues.loadDate, to: dayjs(check("load_date", filterOperatorTypes.lessThanEq)) } }
    }

    if (check(`number_seal`, filterOperatorTypes.eq)) {
        mergeValues = { ...mergeValues, sealNo: check(`number_seal`, filterOperatorTypes.eq) }
    }

    if (check(`repo_number`, filterOperatorTypes.eq)) {
        mergeValues = { ...mergeValues, repoNumber: check(`repo_number`, filterOperatorTypes.eq) }
    }

    // console.log('m', mergeValues, state)

    const formik = useFormik({
        initialValues: mergeValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleSubmit, handleChange, setFieldValue } = formik;

    const RenderMainForm = () => {
        return (
            <Box
                sx={{
                    p: 2
                }}
            >
                {/* {JSON.stringify(values)} */}
                <Grid container spacing={1}>

                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(true)}
                            config={{
                                name: "createDate.from",
                                hasError: Boolean(errors?.createDate?.from),
                                helperText: errors?.createDate?.from,
                                label: t("createDateFrom"),
                                renderValue: ({ values }) => {
                                    return values.createDate.from
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(false)}
                            config={{
                                name: "createDate.to",
                                hasError: Boolean(errors?.createDate?.to),
                                helperText: errors?.createDate?.to,
                                label: t("createDateTo"),
                                renderValue: ({ values }) => {
                                    return values.createDate.to
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(true)}
                            config={{
                                name: "loadDate.from",
                                hasError: Boolean(errors?.loadDate?.from),
                                helperText: errors?.loadDate?.from,
                                label: t("loadDateFrom"),
                                renderValue: ({ values }) => {
                                    return values.loadDate.from
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(false)}
                            config={{
                                name: "loadDate.to",
                                hasError: Boolean(errors?.loadDate?.to),
                                helperText: errors?.loadDate?.to,
                                label: t("loadDateTo"),
                                renderValue: ({ values }) => {
                                    return values.loadDate.to
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={12}>
                        <Divider sx={{ mt: 1, mb: 1 }} />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"repoNumber"}
                            label={t("containerNo")}
                            type="text"
                            variant="outlined"
                            value={values.repoNumber}
                            onChange={handleChange}
                            error={touched.repoNumber && Boolean(errors.repoNumber)}
                            helperText={touched.repoNumber && errors.companyName}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12} md={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"sealNo"}
                            label={t("sealNo")}
                            type="text"
                            variant="outlined"
                            value={values.sealNo}
                            onChange={handleChange}
                            error={touched.sealNo && Boolean(errors.sealNo)}
                            helperText={touched.sealNo && errors.sealNo}
                        />
                    </Grid>
                    {/* <Grid item sm={12} xs={12} md={6}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.documentStatus && Boolean(errors.documentStatus)}
                        >
                            <InputLabel id="documentStatus">Document Status</InputLabel>
                            <Select
                                fullWidth
                                labelId="documentStatus"
                                label="Document Status"
                                name={"documentStatus"}
                                onChange={handleChange}
                                // onChange={(event) => {
                                //     setFieldValue(`branchAccess`, event.target.value)
                                // }}
                                // value={checkExists({ dataSearch: dataBranches, valueToCompare: values.branchAccess })}
                                value={values.documentStatus}
                                sx={{
                                    // textAlign: 'left',
                                    // width: '65%'
                                }}
                            >
                                <MenuItem
                                    value={""}
                                >
                                    {'Any'}
                                </MenuItem>

                                {
                                    ["Approved", "Pending"].map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i}
                                            >
                                                {i}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <FormHelperText>
                                {touched.documentStatus && errors.documentStatus}
                            </FormHelperText>
                        </FormControl>
                    </Grid> */}

                    {/* <Grid item sm={12} xs={12} md={12}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"companyName"}
                            label="Company Name"
                            type="text"
                            variant="outlined"
                            value={values.companyName}
                            onChange={handleChange}
                            error={touched.companyName && Boolean(errors.companyName)}
                            helperText={touched.companyName && errors.companyName}
                        />
                    </Grid> */}



                </Grid>
            </Box>
        )
    }

    const getRule = (props) => ({ ...props })

    const handleApply = () => {

        let filters = []

        if (values?.sealNo) {
            filters.push(getRule({
                name: `number_seal`,
                nameDisplay: "Seal No.",
                operator: filterOperatorTypes.eq,
                value: values?.sealNo,
                valueDisplay: values?.sealNo
            }))
        }

        if (values?.repoNumber) {
            filters.push(getRule({
                // name: "supplier_name",
                name: `repo_number`,
                nameDisplay: "Container No.",
                operator: filterOperatorTypes.eq,
                value: values?.repoNumber,
                valueDisplay: values?.repoNumber
            }))
        }

        if (values?.createDate?.from) {
            filters.push(getRule({
                name: "ax_createdatetime",
                nameDisplay: "Created Date",
                operator: filterOperatorTypes.moreThanEq,
                value: values?.createDate?.from.format("YYYY-MM-DD"),
                valueDisplay: values?.createDate?.from.format("YYYY-MM-DD")
            }))
        }

        if (values?.createDate?.to) {
            filters.push(getRule({
                name: "ax_createdatetime",
                nameDisplay: "Created Date",
                operator: filterOperatorTypes.lessThanEq,
                value: values?.createDate?.to.format("YYYY-MM-DD"),
                valueDisplay: values?.createDate?.to.format("YYYY-MM-DD")
            }))
        }

        if (values?.loadDate?.from) {
            filters.push(getRule({
                name: "load_date",
                nameDisplay: "Load Date",
                operator: filterOperatorTypes.moreThanEq,
                value: values?.loadDate?.from.format("YYYY-MM-DD"),
                valueDisplay: values?.loadDate?.from.format("YYYY-MM-DD")
            }))
        }

        if (values?.loadDate?.to) {
            filters.push(getRule({
                name: "load_date",
                nameDisplay: "Load Date",
                operator: filterOperatorTypes.lessThanEq,
                value: values?.loadDate?.to.format("YYYY-MM-DD"),
                valueDisplay: values?.loadDate?.to.format("YYYY-MM-DD")
            }))
        }

        // console.log('filters', filters)

        dispatch({ type: actionTypes.updateAllRules, payload: filters })
        dispatch({ type: actionTypes.updateColumns, payload: columns })
        closeCustomDrawer();

    }

    const RenderMain = () => {

        // console.log(formik.values)

        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%'
                        // alignItems: 'center'
                    }}
                >
                    {/* {JSON.stringify(values)} */}
                    {
                        RenderMainForm()
                    }

                    {/* <Divider sx={{ mt: 1, mb: 1 }} /> */}

                    <Button
                        type="submit"
                        // fullWidth
                        variant="contained"
                        sx={{
                            m: 2
                        }}
                    // loading={isLoading}
                    // onClick={handleApply}
                    >
                        {t("applyFilters")}
                    </Button>

                </Box>

            </form>
        )
    }

    return (
        <Box
            sx={{
                // flex: 1,
                height: '100%',
            }}
        >
            {
                RenderMain()
            }

            {/* <Button
                onClick={() => {
                    console.log('sdfdsfds')
                    dispatch({ type: actionTypes.addRule, payload: { aaa: 1111 } })
                }}
            >
                Add Rule
            </Button>

            <Button
                onClick={() => {
                    console.log('22222')
                    // dispatch({ type: actionTypes.showFilter, payload: { status: false } })
                    closeCustomDrawer()
                }}
            >
                Close it
            </Button> */}

        </Box>
    )
}